import { unsupportedNodeAttribute as unsupportedNodeAttributeFactory } from '../../next-schema/generated/markTypes';
export var unsupportedNodeAttribute = unsupportedNodeAttributeFactory({
  toDOM: function toDOM() {
    return ['span'];
  }
});